<div class="container">
    <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
        <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
        <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub2}}</h1>
        <div class="col-sm-6 col-md-6 col-xl-4 m-auto px-0">
            <div class="form-group mt-3 mb-0" style="margin-bottom:0px !important">
                <input type="text" numbersOnly min="1" placeholder="Enter SF" id="sqft" oninput="validity.valid||(value='');" (keydown.space)="$event.preventDefault()" class="form-control"
                    [(ngModel)]="sqft" (keyup)="enableButton()" (keyup.enter)="getSqft();"/>
            </div>
            <p class="m-0 text-muted" style="font-size:18px">SF</p>
        </div>
        <button *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'combtn': disablebutton}" (click)="getSqft();">Next</button>
        <div class="mt-5">
            <div class="m-auto col-sm-12 col-md-6 col-xl-6 blockbg boxclr text-center">
                <img src="assets/images/flash.png" class="mb-1" />
                <p class="text-center tiphead">Min SF to Max SF</p>
                <p class="text-center tipmes">{{questionObj.tip}}</p>
            </div>
        </div>
    </div>
</div>
<div class="container mobileview px-0" [attr.id]="questionObj._id" style="float:left;">
    <div class="d-flex h-100 row col-sm-12 pr-0">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/logo-charcoal.png" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box">
                <h1 class="questionMob text-left">{{question}}</h1>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
        <div class="col-9 offset-col-3 px-0 d-flex flex-wrap pull-right">
            <div class="col-8 px-0">
                <form #f="ngForm" (ngSubmit)="getSqft();" novalidate> 
                    <div class="form-group">
                        <input type="tel" numbersOnly min="1" name="sqft" id="sqft_mob" oninput="validity.valid||(value='');" (keydown.space)="$event.preventDefault()" placeholder="Enter SF" class="form-control"
                            [(ngModel)]="sqft" (focusout)="getSqft();" (keyup.enter)="getSqft();" />
                    </div>
                </form>
            </div>
            <div class="col-4 pr-0">
                <p class="text-muted mt-1">SF</p>
            </div>
        </div>
        </div>
        <div class="clear"></div>
        <div class="col-12">
            <div class="pr-3"style="text-align: right;">
                <div *ngIf="disablebutton" class="ash_box text-right mb-3">
                    <h1 class="ansMob text-right">{{sqft}} SF</h1>
                </div>
            </div>
        </div>
        <div class="clear"></div>
    </div>
    <div class="clear"></div>
    <div class="col-12 mb-3">
        <div class="blockbg boxclr p-2">
            <img src="assets/images/flash.png" class="mb-1" style="margin-left:48%" />
            <p class="text-center tiphead">Min SF to Max SF</p>
            <p class="text-center tipmes">{{questionObj.tip}}</p>
        </div>
    </div>
    <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/logo-charcoal.png" />
        </div>
        <div class="col-sm-2 col-2 px-0 my-auto">
            <div class="arrow_box">
                <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
            </div>
        </div>
    </div>
    
</div>
